import { ERROR_MSG_UNKNOWN_ERROR } from "@/constants/message.constants";

export const logErrorsToGoogleAnalytics = (errorMessagesArray, productId) => {
  if (
    Array.isArray(errorMessagesArray) &&
    errorMessagesArray.length &&
    productId
  ) {
    errorMessagesArray.forEach((errorMessage) => {
      window.dataLayer.push({
        event: "form_error",
        errorMessage: errorMessage,
        product: productId,
      });
    });
  } else {
    window.dataLayer.push({
      event: "form_error",
      errorMessage: ERROR_MSG_UNKNOWN_ERROR,
      product: null,
    });
  }
};
